// src/pages/Wallet/ReceiveModal.js
import React, { useState, useEffect } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { useTranslation } from 'react-i18next';
import './ReceiveModal.css';

// SVG icon components to replace react-icons
const CopyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
  </svg>
);

const CheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"></polyline>
  </svg>
);

const ReceiveModal = ({ isOpen, onClose, address }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const [formattedAddress, setFormattedAddress] = useState('');
  
  // Format the address with spaces for better readability
  useEffect(() => {
    if (address) {
      // Keep the 0x prefix, then add a space every 6 characters for better readability
      const formatted = address.replace(/^(0x)(.{6})(.{6})(.{6})(.{6})(.{6})(.{6})(.*)$/, 
        (_, prefix, a, b, c, d, e, f, g) => `${prefix} ${a} ${b} ${c} ${d} ${e} ${f} ${g}`);
      setFormattedAddress(formatted);
    }
  }, [address]);

  // Copy icon reverts after 2 seconds
  const COPY_TIMEOUT = 2000;

  if (!isOpen) return null;

  // If no address is passed, show a placeholder
  const displayAddress = address || '0x0000000000000000000000000000000000000000';
  const displayFormatted = formattedAddress || displayAddress;

  // Handler to copy to clipboard
  const handleCopy = () => {
    navigator.clipboard.writeText(displayAddress);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, COPY_TIMEOUT);
  };

  return (
    <div className="receive-modal-overlay" onClick={onClose}>
      <div className="receive-modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>{t('wallet.receiveFunds')}</h2>
        <p className="address-label">{t('wallet.walletAddress')}</p>

        {/* Address + Copy icon */}
        <div className="address-row">
          <span className="address-value">{displayFormatted}</span>
          <div 
            className={`copy-icon-receive ${copied ? 'copied' : ''}`}
            onClick={handleCopy}
            title={t('actions.copy')}
          >
            {copied ? <CheckIcon /> : <CopyIcon />}
          </div>
        </div>

        <div className="qr-code-container">
          <QRCodeCanvas
            value={displayAddress}
            size={220}
            bgColor="#1a1a1a"
            fgColor="#ffffff"
            level="H"
            includeMargin={true}
          />
        </div>

        <button className="close-button-recieve" onClick={onClose}>{t('actions.close')}</button>
      </div>
    </div>
  );
};

export default ReceiveModal;